import dynamic from 'next/dynamic';
import { Dialog } from '@mui/material';

import { Loading } from '@/components/loading/Loading';

import type { FilePickerProps } from './FilePicker';

const FilePickerComponent = dynamic(
  () => import('./FilePicker').then((module) => module.FilePicker),
  {
    loading: Loading,
  },
);

interface Props extends FilePickerProps {
  open: boolean;
  onClose: () => void;
}

export const FilePicker = ({ open, onClose, ...other }: Props) => {
  return (
    <Dialog
      sx={{ alignItems: 'flex-start' }}
      fullWidth
      open={open}
      onClose={onClose}
      aria-labelledby="folder-selector-dialog-title"
    >
      <FilePickerComponent {...other} onClose={onClose} />
    </Dialog>
  );
};
